// Layout contracts a route needs because of how the app shell is built.
//
// The shell (`app_layout.tsx`) is full-bleed at every width: it spends no
// space on a frame, so a route owns the gutter between its content and the
// screen edge. Reach for these instead of restating the values, so the
// contract has one place to change.

// How far a route's content sits from the screen edge. A phone has the least
// width to spare, so the gutter narrows rather than the content.
//
// Use this directly for a full-width band whose own vertical rhythm differs —
// a header strip with a `border-b`, say, whose border must span the full width
// while its text stays aligned with the content below it.
export const APP_PAGE_GUTTER_X_CLASSNAME = 'px-4 md:px-6';

// The gutter for a route's outermost element: the horizontal contract above
// plus matching vertical padding. Composed rather than spelled out, so the two
// cannot drift apart. Several admin pages had already settled on these values
// independently; the shell used to supply them on mobile as well, which is
// what made the two disagree.
export const APP_PAGE_GUTTER_CLASSNAME = `${APP_PAGE_GUTTER_X_CLASSNAME} py-4 md:py-6`;

// The frame shared by the redesigned list pages (`ui_v3_components`):
// a capped measure that insets from the screen edge on a phone and switches to
// a viewport-relative gutter from `md` up. Callers add their own flow spacing
// (`gap-5` or `space-y-5`) and any card resets, which legitimately differ.
export const LIST_PAGE_FRAME_CLASSNAME =
    'max-w-[1360px] px-4 py-4 md:w-[calc(100%_-_3rem)] md:px-0 md:pt-10 md:pb-6';
